module.exports = __webpack_public_path__ + "static/media/ina.97630c1d.svg";